import { Icon, IconName, IconProps } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"

type InfoIconProps = Omit<IconProps, "icon"> & {
  onClick?: any
  icon?: IconName
}
const InfoIcon = ({
  className,
  icon = "info-sign",
  ...props
}: InfoIconProps) => {
  return (
    <Icon
      className={classNames("vt-info-icon", className)}
      icon={icon}
      {...props}
    />
  )
}

export default InfoIcon
